import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("image", component(opts));
  editor.BlockManager.add("image", block(opts));
};